import { useEffect, useState } from "react";

export interface IUseWatchStateProps<T> {
  /**
   * Parent value to be watched. When it changes - inner state changes accordingly
   */
  value: T;
}

/**
 * Hook that allows to make the "useState" and watches changes from parent value
 */
function useWatchState<T>({ value }: IUseWatchStateProps<T>) {
  const [valueState, setValueState] = useState<T>(value);

  useEffect(() => {
    setValueState(value);
  }, [value]);

  return [valueState, setValueState] as const;
}

export default useWatchState;
